<div class="bp-modal">
  <bp-modal-header class="large-weight" [title]="'add_pricealert' | translate: [tradable?.getSymbol(false, true)]">
    <a right (click)="close()" (keydown.enter)="close()" [tabIndex]="0">{{ "abort" | translate }}</a>
  </bp-modal-header>
  <div class="bp-modal-body">
    <div class="bp-modal-body-section pb-25">
      <div class="bp-modal-body-section-responsive-padding">
        <div class="text-center mb-35 mr-25 ml-25 text-color">
          {{ "we_will_send_yuo_an_email_when_your_price_is_reached" | translate }}
        </div>
        <div class="form-group">
          <label>{{ "asset_name_label" | translate }}</label>
          <bp-input
            class="mb-5"
            [iconLeading]="true"
            [iconUrl]="tradable.getLogo()"
            [value]="tradable.getName()"
            [disabled]="true">
          </bp-input>
        </div>
        @if (show) {
          <bp-input
            [label]="'target_price' | translate"
            [type]="'text'"
            [textInside]="{ id: data?.getFiatId(), symbol: fiatSymbol } | fiat_symbol"
            [(value)]="amount"
            (onKeyEnter)="save()">
            <span class="help-block text-light font-size-13">
              {{ "current_price" | translate }}:
              {{
              getAvgPrice()
              | fiat_precision_symbol
              : { id: fiat?.getId(), currencies: [fiat, tradable], symbol: true }
              }}
            </span>
          </bp-input>
        }
        @if (!show) {
          @if (restoreInput()) {
          }
        }
        <div class="pricealarm-percent">
          @for (button of priceButtons; track button) {
            <a
              class="pricealarm-percent-button large-weight"
              (click)="adjustPriceAlert(button)"
              (keydown.enter)="adjustPriceAlert(button)"
              [tabIndex]="0">
              {{ button | percent_symbol }}
            </a>
          }
        </div>
      </div>
      <div class="mt-40">
        <a class="price-alert-button btn btn-primary btn-block btn-lg font-medium" (click)="save()">
          {{ "save_new_pricealert" | translate }}
        </a>
      </div>
    </div>
  </div>
</div>
